'use strict'

import Vue from 'vue'
import axios from 'axios'
import mainVue from '@/main'
import { postUrl } from "@/config/index";


sessionStorage.setItem('postUrl', postUrl)

let config = {
    baseURL: process.env.NODE_ENV === 'development' ? '/api' : `${postUrl}/index.php/api`,
}

const _coreApi = axios.create(config)

// Intercept request
_coreApi.interceptors.request.use(
    function(request) {
        // Set token

        switch (request.method) {
            case 'get':
                // Prevent caching issue
                if (request.url.indexOf('?') == -1) {
                    request.url = request.url + '?_=' + Math.random()
                } else {
                    request.url = request.url + '&_=' + Math.random()
                }
                break;
            case 'post':
                // POST using x-www-form-urlencoded
                request.headers['content-type'] = 'application/json'
                // request.data = qs.stringify(request.data)
                break;
        }

        return request
    },
    function(error) {
        return Promise.reject(error)
    }
)

// Intercept response
_coreApi.interceptors.response.use(
    function(response) {

        // Process response data
        let res = response.data

        if (typeof res === 'string') {
            res = res.replace(/\\n/g, "\\n")
                .replace(/\\'/g, "\\'")
                .replace(/\\"/g, '\\"')
                .replace(/\\&/g, "\\&")
                .replace(/\\r/g, "\\r")
                .replace(/\\t/g, "\\t")
                .replace(/\\b/g, "\\b")
                .replace(/\\f/g, "\\f");
            // remove non-printable and other non-valid JSON chars
            res = res.replace(/[\u0000-\u0019]+/g, "");
            res = JSON.parse(res);
        }

        // 拦截器
        if (res.code == 200) {
            return res.data
        } else {

            return Promise.reject(mainVue.$t(`request.${[res.code]}`))
        }
    },
    function(error) {
        return Promise.reject(error.response.statusText)
    }
)

let CoreApiPlugin = {}

// eslint-disable-next-line
CoreApiPlugin.install = function(Vue, options) {
    Vue.coreApi = _coreApi
    window.coreApi = _coreApi
    Object.defineProperties(Vue.prototype, {
        $request: {
            get() {
                return _coreApi
            }
        }
    })
}

Vue.use(CoreApiPlugin)

export default CoreApiPlugin
